import * as React from "react"
import {
  RadioButtonFieldBlock,
  RadioButtonFieldBlockProps,
} from "gatsby-interface"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"
import { NotificationEventType } from "@modules/graphql/types"
import { notificationEventTypeLabels } from "./constants"

const createEventOptionCb = (value: NotificationEventType) => ({
  value,
  label: notificationEventTypeLabels[value],
})

const eventOptions = [
  NotificationEventType.BuildSucceeded,
  NotificationEventType.BuildFailed,
  NotificationEventType.BuildTimeout,
  NotificationEventType.PreviewSucceeded,
  NotificationEventType.PreviewFailed,
  NotificationEventType.PreviewTimeout,
  NotificationEventType.DeploySucceeded,
  NotificationEventType.DeployFailed,
].map(createEventOptionCb)

export type NotificationEventFieldProps = Omit<
  RadioButtonFieldBlockProps,
  "label" | "options"
>

export function NotificationEventField(props: NotificationEventFieldProps) {
  return (
    <RadioButtonFieldBlock
      label={notificationDeploysText.labels.eventToListen}
      options={eventOptions}
      {...props}
    />
  )
}
